import { useEffect } from "react";

import styled from "styled-components/macro";

import { useCellMeasurements } from "Boards";

import { formatNumberWithCommas } from "Utilities/Number";

import { Cell } from "./";
import { CELL_TYPES, getCellType } from "./Dynamic";

export function FooterCell({ columnID, columnType, total }) {
  const { MeasureCell, remeasureCell } = useCellMeasurements({ columnID });

  useEffect(() => remeasureCell(), [total]);

  const cellType = getCellType(columnType);

  return (
    <>
      <FooterRowCell columnID={columnID} columnType={columnType}>
        <FooterCellContent cellType={cellType} total={total} />
      </FooterRowCell>
      <MeasureCell>
        <FooterCellContent cellType={cellType} total={total} />
      </MeasureCell>
    </>
  );
}

const FooterRowCell = styled(Cell)`
  height: 32px;
  border-bottom: none;
  font-weight: 400;
  text-align: center;
  justify-content: center;
`;

function FooterCellContent({ cellType, total }) {
  switch (cellType) {
    case CELL_TYPES.BOOL:
      return (
        <>
          <Icon className="fas fa-check-circle" />
          {formatNumberWithCommas(total || "0")}
        </>
      );
    case CELL_TYPES.NUMBER:
      return (
        <>
          <Icon className="far fa-plus-square" />
          {formatNumberWithCommas(getRoundedValue(total) || "0")}
        </>
      );
    default:
      return null;
  }
}

const Icon = styled.span`
  display: inline-block;
  margin-right: 4px;
`;

function getRoundedValue(number) {
  return Math.round((Number(number) + Number.EPSILON) * 100) / 100;
}
